/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Byoa_EmptyInputs */

const en_byoa_empty = /** @type {(inputs: Byoa_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No AI connection yet. Bystep uses your included steps.`)
};

const id_byoa_empty = /** @type {(inputs: Byoa_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada koneksi AI. Bystep memakai jatah langkahmu.`)
};

/**
* | output |
* | --- |
* | "No AI connection yet. Bystep uses your included steps." |
*
* @param {Byoa_EmptyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_empty = /** @type {((inputs?: Byoa_EmptyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_EmptyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_empty(inputs)
	return en_byoa_empty(inputs)
});